// extracted by mini-css-extract-plugin
export default {"dialog":"fbJyiJgJ6wRwCySN3Afa"};